/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportLink = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 19a4 4 0 0 1 4-4h2v2h-2a2 2 0 1 0 0 4h2v2h-2a4 4 0 0 1-4-4zm13 0a4 4 0 0 1-4 4h-2v-2h2a2 2 0 1 0 0-4h-2v-2h2a4 4 0 0 1 4 4z" />
        <path d="M19 20h-5v-2h5z" />
        <path d="M2 2v20h6.803a5.96 5.96 0 0 1-.72-2H4V4h16v9h2V2zm14.584 11a5 5 0 1 0-7.252 2.23 6.03 6.03 0 0 1 1.64-1.41A3.001 3.001 0 0 1 11 8.17v4.593l3.941-2.357A2.989 2.989 0 0 1 14.236 13zm-8.243 4H6v2h2c0-.701.12-1.374.341-2zM13 9.237V8.17c.336.119.645.296.914.519z" />
      </g>
    </g>
  </Icon>
);
export { SvgReportLink as ReportLink };
